"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = exports.DistributorText = exports.DistributorLinkBlock = exports.ViewInCartButton = exports.LoaderIcon = exports.AddToCartButton = exports.AmountControllerBlock = exports.AdditionalChargeValue = exports.AdditionalChargeBlock = exports.UnitPriceBlock = exports.Container = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../../Components/UI/Typography"));
const Button_1 = __importDefault(require("../../../Button"));
const svg_components_1 = require("../../../../assets/svg-components");
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
exports.Container = styled_components_1.default.div `
  width: 100%;
  padding: ${props => props.theme.spacing.s4}px;
  border: 1px solid ${props => props.theme.palette.LIGHT_BLACK};
`;
exports.UnitPriceBlock = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.AdditionalChargeBlock = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.AdditionalChargeValue = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.bold};
`;
exports.AmountControllerBlock = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.s4}px;
`;
exports.AddToCartButton = (0, styled_components_1.default)(Button_1.default) `
  width: 100%;
  margin-top: ${props => props.theme.spacing.s4}px;
  height: ${props => props.theme.spacing.m6}px;
  ${props => props.disabled && `background: ${props.theme.palette.BLUE_60};`}
`;
exports.LoaderIcon = (0, styled_components_1.default)(svg_components_1.GradientLoaderIcon) `
  -webkit-animation: ${props => props.theme.themeKeyframes.rotation} 1s infinite linear;
  width: ${props => props.theme.constants.blockHeight.s12}px;
  height: ${props => props.theme.constants.blockHeight.s12}px;
`;
exports.ViewInCartButton = (0, styled_components_1.default)(Button_1.default) `
  width: 100%;
  margin-top: ${props => props.theme.spacing.s4}px;
  background: ${props => props.theme.palette.ORANGE_100};
`;
exports.DistributorLinkBlock = styled_components_1.default.a `
  display: flex;
  justify-content: center;
  margin-top: ${props => props.theme.spacing.s4}px;
`;
exports.DistributorText = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s2}px;
`;
exports.WarningIcon = (0, styled_components_1.default)(svg_components_1.WarningIcon) `
  flex-shrink: 0;
`;
exports.default = {
    Wrapper: exports.Wrapper,
    Container: exports.Container,
    UnitPriceBlock: exports.UnitPriceBlock,
    AdditionalChargeBlock: exports.AdditionalChargeBlock,
    AdditionalChargeValue: exports.AdditionalChargeValue,
    AmountControllerBlock: exports.AmountControllerBlock,
    AddToCartButton: exports.AddToCartButton,
    LoaderIcon: exports.LoaderIcon,
    ViewInCartButton: exports.ViewInCartButton,
    DistributorLinkBlock: exports.DistributorLinkBlock,
    DistributorText: exports.DistributorText
};
